var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('bar-chart',{attrs:{"data":_vm.chart,"thousands":",","label":_vm.legend,"legend":"left"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }